import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box
} from '@mui/material';
import {
  Menu as MenuIcon,
  ArrowBack as ArrowBackIcon,
  MoreVert as MoreVertIcon
} from '@mui/icons-material';

const TopAppBar = ({
  title = 'Title',
  showBackButton = false,
  showMenuButton = true,
  showMoreButton = false,
  onBackClick,
  onMenuClick,
  onMoreClick,
  elevation = 0,
  sx = {},
  ...props
}) => {
  return (
    <AppBar 
      position="static" 
      elevation={elevation}
      sx={{
        backgroundColor: '#ffffff',
        color: '#000000',
        boxShadow: 'none',
        borderBottom: '1px solid #e0e0e0',
        ...sx
      }}
      {...props}
    >
      <Toolbar sx={{ 
        minHeight: '56px',
        paddingLeft: '4px',
        paddingRight: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        
        {/* Left Section */}
        <Box sx={{ width: '48px', display: 'flex', justifyContent: 'flex-start' }}>
          {showBackButton && (
            <IconButton
              onClick={onBackClick}
              sx={{ 
                color: '#000000',
                padding: '12px'
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          {!showBackButton && showMenuButton && (
            <IconButton
              onClick={onMenuClick}
              sx={{ 
                color: '#000000',
                padding: '12px'
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>

        {/* Center Section - Title */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '24px',
              color: '#000000',
              textAlign: 'center'
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ width: '48px', display: 'flex', justifyContent: 'flex-end' }}>
          {showMoreButton && (
            <IconButton
              onClick={onMoreClick}
              sx={{ 
                color: '#000000',
                padding: '12px'
              }}
            >
              <MoreVertIcon />
            </IconButton>
          )}
        </Box>

      </Toolbar>
    </AppBar>
  );
};

export default TopAppBar;
